import AddIcon from '@mui/icons-material/Add';
import { DeleteForever } from '@mui/icons-material';
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
    TextField,
    Box
} from "@mui/material";

const FromSchemeForm = ({
    handleChallanFormData, 
    schemeLoading, 
    screenType,
    fromSchemeDetails, 
    subheadsList, 
    fromSubheadData, 
    handleSubheadChange, 
    handleFinancialYearChange, 
    fy_list, 
    schemes, 
    handleSchemeChange,
    totalFromAmount,
    handleFromActivityChange,
    activity,
    findSubActivitiesById,
    addNewActivity,
    deleteNewActivity,
    handleFromSubheadSave,
    formData
}) => {
    return (
        <>
            <div className='col-md-12'>
                <h5>From Scheme</h5>
            </div>
            <div className='col-md-4 p-2'>
                <FormControl fullWidth>
                    <InputLabel id="financial-year-label">Financial Year *</InputLabel>
                    <Select
                        labelId="financial-year-label"
                        id="financial_year"
                        name='financial_id'
                        value={fromSchemeDetails.financial_id || ""}
                        onChange={handleFinancialYearChange}
                        disabled={schemeLoading || !formData?.department_id || screenType == "View" || screenType == "Edit"}
                        label="Financial Year *"
                    >
                        <MenuItem value="">---select year---</MenuItem>
                        {fy_list.map((fy) => (
                            <MenuItem value={fy.id} key={fy.id}>{fy.year}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <InputLabel id="from-scheme-label">Scheme *</InputLabel>
                    <Select
                        labelId="from-scheme-label"
                        id="from_scheme_id"
                        name='from_scheme_id'
                        value={fromSchemeDetails.scheme_id || ""}
                        disabled={screenType == "View" || screenType == "Edit"}
                        onChange={handleSchemeChange}
                        label="Scheme *"
                    >
                        <MenuItem value="">Select Scheme</MenuItem>
                        {schemes.map((scheme) => (
                            scheme.l2_status == 1 && scheme.l3_status == 1 &&
                            <MenuItem value={scheme.id} key={scheme.id}>{scheme.code}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Scheme Name" type="text" value={fromSchemeDetails.scheme_name} inputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Department Name" type="text" value={fromSchemeDetails.department_name} inputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Grant Code" type="text" value={fromSchemeDetails.grant_code} inputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Type of Scheme" type="text" value={fromSchemeDetails.scheme_type} inputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            <div className='col-md-12 mt-3'>
                <h5>From Subhead</h5>
            </div>
            <div className='col-md-4 p-2'>
                <FormControl fullWidth>
                    <InputLabel id="subhead-label">Subhead *</InputLabel>
                    <Select
                        labelId="subhead-label"
                        id="from_subhead_id"
                        name='from_subhead_id'
                        value={fromSubheadData.from_subhead_id || ""}
                        onChange={handleSubheadChange}
                        disabled={!fromSchemeDetails.scheme_id || screenType == "View"}
                        label="Subhead *"
                    >
                        <MenuItem value="">---Select Subhead---</MenuItem>
                        {subheadsList.map((subhead) => (
                            <MenuItem value={subhead.id} key={subhead.id}>{subhead.code}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Subhead Name" type="text" value={fromSubheadData.subhead_name} inputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Subhead Balance" type="text" value={fromSubheadData.subhead_balance} inputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    
                    {(fromSchemeDetails.is_activity_active == 1 && fromSchemeDetails.monitoring_level == "1") && <TextField
                        label="Reappropriation Amount"
                        type="text"
                        value={totalFromAmount.current}
                        inputProps={{ readOnly: true }}
                        disabled={true}
                    />}
                    {(fromSchemeDetails.is_activity_active == 1 && (fromSchemeDetails.monitoring_level == "3" && formData.department_type != 'T1')) && <TextField
                        label="Reappropriation Amount"
                        type="text"
                        value={totalFromAmount.current}
                        inputProps={{ readOnly: true }}
                        disabled={true}
                    />}
                    
                    {(fromSchemeDetails.is_activity_active == 0  || (fromSchemeDetails.is_activity_active == 1 && fromSchemeDetails.monitoring_level == "2") || (fromSchemeDetails.is_activity_active == 1 && fromSchemeDetails.monitoring_level == "3" && formData.department_type == 'T1')) && <TextField
                        label="Reappropriation Amount"
                        type="text"
                        name="from_reappropriation_amount"
                        value={fromSubheadData.from_reappropriation_amount}
                        onChange={handleChallanFormData}
                    />}
                </FormControl>
            </div>
            {fromSchemeDetails.is_activity_active == '1' && ((fromSchemeDetails.monitoring_level == "3" && formData.department_type != 'T1') || (fromSchemeDetails.monitoring_level == "1")) && <div className="col-md-12" style={{ marginTop: '20px' }}>
                <table className="table table-bordered" style={{ tableLayout: 'auto' }}>
                    <thead className="text-center-custom">
                        <tr>
                            <th scope="col" width="150px">Activity</th>
                            <th scope="col" width="150px">Subactivity</th>
                            <th scope="col" width="300px">Available Balance</th>
                            <th scope="col" width="300px">Amount</th>
                            <th scope="col" width="150px">Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-center-custom">
                        {fromSubheadData?.activity.map((activityData, index) => (
                            <tr key={index}>
                                <td>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            name='activity_id'
                                            value={activityData.activity_id || ""}
                                            onChange={(e) => handleFromActivityChange(index, e)}
                                            disabled={!fromSubheadData.from_subhead_id}
                                            displayEmpty
                                        >
                                            <MenuItem value="">---Select---</MenuItem>
                                            {activity.map(activity => {
                                                if (fromSubheadData?.activity_budget && fromSubheadData?.activity_budget.length) {
                                                    const exists = fromSubheadData?.activity_budget.find(e => e.subhead_activity_id == activity.id);

                                                    if (exists) {
                                                        return (
                                                            <MenuItem key={activity.id} value={activity.id}>{activity.activity}</MenuItem>
                                                        )
                                                    }
                                                }
                                                else {
                                                    if (fromSchemeDetails.monitoring_level == "2") {
                                                        return (
                                                            <MenuItem key={activity.id} value={activity.id}>{activity.activity}</MenuItem>
                                                        )
                                                    }
                                                }
                                            })}
                                        </Select>
                                    </FormControl>
                                </td>
                                <td>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            name='subactivity_id'
                                            value={activityData.subactivity_id || ""}
                                            onChange={(e) => handleFromActivityChange(index, e, activityData.activity_id)}
                                            disabled={!fromSubheadData.from_subhead_id}
                                            displayEmpty
                                        >
                                            <MenuItem value="">---Select---</MenuItem>
                                            {findSubActivitiesById(activityData.activity_id).map(e => {
                                                if (fromSubheadData?.activity_budget && fromSubheadData?.activity_budget.length) {
                                                    const exists = fromSubheadData?.activity_budget.find(item => item.subhead_subactivity_id == e.id);
                                                    if (exists) {
                                                        return (
                                                            <MenuItem key={e.id} value={e.id}>{e.subactivity}</MenuItem>
                                                        )
                                                    }
                                                }
                                                else {
                                                    if (fromSchemeDetails.monitoring_level == "2") {
                                                        return (
                                                            <MenuItem key={e.id} value={e.id}>{e.subactivity}</MenuItem>
                                                        )
                                                    }
                                                }
                                            })}
                                        </Select>
                                    </FormControl>
                                </td>
                                <td>{fromSubheadData?.activity_budget && fromSubheadData?.activity_budget.length != 0 && fromSubheadData?.activity_budget.find(e =>
                                    e.subhead_activity_id === activityData.activity_id &&
                                    e.subhead_subactivity_id === activityData.subactivity_id
                                )?.budget}</td>
                                <td>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="number"
                                        name='budget'
                                        placeholder="Enter Release Budget"
                                        value={activityData?.budget}
                                        disabled={!fromSubheadData.from_subhead_id || screenType == "View"}
                                        onChange={(e) => handleFromActivityChange(index, e)}
                                    />
                                </td>
                                <td>
                                    <button className="btn btn-primary mx-2" onClick={(e) => addNewActivity('from')}>
                                        <AddIcon />
                                    </button>
                                    {index != 0 && <button type="button"
                                        className="btn btn-danger mx-2"
                                        onClick={(e) => deleteNewActivity(index, 'from')}>
                                        <DeleteForever /></button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>}
            {screenType != 'View' && <div className='col-md-12'><button type="button" onClick={handleFromSubheadSave} className='btn btn-primary mt-2'>Add From Subhead</button></div>}
        </>
    );
}

export default FromSchemeForm;